// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { Tournament } from "./../../models/tournament";
// Services

import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import { AngularFireDatabase } from "angularfire2/database";

@Component({
  templateUrl: "./social-dashboard.component.html",
})
export class SocialDashboardComponent implements OnInit {
  public user;
  public stats = {
    Allpost: 0,
    myPost: 0,
    notification: 0,
  };
  public followRequest = 0;
  public followerCount = 0;

  constructor(
    private apiService: ApiService,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase
  ) {}

  async ngOnInit() {
    this.user = this.oAuthService.getClub();
    if (this.user.type == 3) this.getPosts();
    this.myPost();
    await this.getFollowers();
    await this.FollowerRequest();
    this.notification();
    this.apiService
      .object("user-push/" + this.user.cid + "/disabled")
      .then((res) => {
        this.user.disabled = res.$value ? false : true;
      });
  }
  getPosts() {
    const fireList = this.fireDatabase.list(`/index/posts`).subscribe(
      (result) => {
        const i = result.length;
        this.stats.Allpost = i;
        console.log(this.stats);
        if (fireList) fireList.unsubscribe();
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getFollowers() {
    let promise = new Promise((resolve, reject) => {
      const fireObject = this.fireDatabase
        .object(`/user-followers/${this.user.cid}`)
        .subscribe((result) => {
          if (result && result.count) {
            this.followerCount = result.count;
            resolve();
          } else {
            resolve();
          }
        });
    });
    return promise;
  }
  async FollowerRequest() {
    let data = await this.apiService.list(
      `/user-follow-request/${this.user.cid}`
    );

    this.followRequest = data.length;
    return;
  }

  myPost() {
    const fireList = this.fireDatabase
      .list(`/users-posts/` + this.user.cid)
      .subscribe(
        (result) => {
          const i = result.length;
          this.stats.myPost = i;
          console.log(this.stats);
          if (fireList) fireList.unsubscribe();
        },
        (error) => {
          console.error(error);
        }
      );
  }
  notification() {
    const fireList = this.fireDatabase
      .object(`/user-notifications/${this.user.cid}/count`)
      .subscribe(
        (result) => {
          console.log(result);

          if (result.$exists()) {
            this.stats.notification = result.$value;
          }

          if (fireList) fireList.unsubscribe();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  onAccountChange(event) {
    event = event ? null : true;
    console.log(this.user.cid, event);

    this.apiService.set("user-push/" + this.user.cid + "/disabled", event);
  }
}
